module.exports = __webpack_public_path__ + "img/modern.7dfa8325.png";